export const FORM_ANIMATION_DURATION = 100;
export const TABLET_MEDIA_QUERY = `(max-width: 768px)`;
